import React from 'react';
import {useSelector} from "react-redux";
import StaticAssetForITM from "./StaticAssetForITM";
import DashBoard_Asset_IAM from "./DashBoard_Asset_IAM";

function StaticAssetDivideByPlatForm(props) {

    const platFrom = useSelector(state =>state.auth.platFrom)

if(platFrom==='ITM') {
    return (
        <StaticAssetForITM />
    );
}else if(platFrom==='IAM'){
    return (
        <DashBoard_Asset_IAM />
    );
}

}

export default StaticAssetDivideByPlatForm;
